interface Scripts {
    name: string;
    src: string;
}
export const ScriptStore: Scripts[] = [
    { name: 'filepicker', src: 'https://api.filestackapi.com/filestack.js' },
    { name: 'rangeSlider', src: '../../../assets/js/ion.rangeSlider.min.js' },
    { name: "kendo", src: "https://kendo.cdn.telerik.com/2019.2.619/js/kendo.all.min.js" },
    { name: "jquery", src: "https://cdnjs.cloudflare.com/ajax/libs/jquery/3.4.1/jquery.min.js" }
];